import { Box, Grid, Typography } from '@mui/material';

interface PropsContainer {
    children?: any;
    title?: string;
}

export const ContainerChat = ({
    children,
    title = 'Previsora',
}: PropsContainer) => {
    return (
        <Box sx={{ width: '100%', maxWidth: 1500, margin: '0 auto' }}>
            <Grid className="container-crmware-previsora-form">
                <Grid className="container crmware-previsora-form">
                    <Grid container>
                        <Grid item xs={12} position="relative">
                            <Grid
                                position="absolute"
                                width="10%"
                                height="100%"
                                display="flex"
                                alignItems="center"
                            ></Grid>
                            <Grid className="crmware-previsora-title-form">
                                <Typography variant="h2">{title}</Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid className="crmware-previsora-container-form">
                        <Box sx={{ width: '100%' }}>
                            <Grid className="crmware-previsora-wecallyou-containter">
                                {children}
                            </Grid>
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
};
